const publicPath = process.env.BASE_URL;
const result = async () => {
    const result = await fetch(`${publicPath}config/settings.json`);
    if (result.status !== 200) return null;
    return await result.json();
};

export default result;
